import { z } from 'zod';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter.js';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

/**
 * @description Checks if a passed value is a valid ISO 8601 date string.
 * @param value
 */
export const checkIsIsoDate = (value: unknown): value is string => {
  return z
    .string()
    .refine(
      (value: unknown) => {
        if (typeof value !== 'string') {
          return false;
        }

        const parsedDate = dayjs.utc(value, 'YYYY-MM-DDTHH:mm:ssZ', true);

        return parsedDate.isValid();
      },
      { message: 'Invalid ISO date' },
    )
    .safeParse(value).success;
};
